import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React, { useEffect } from 'react';
import { ReportParameter } from '../../ReportViewer/ReportViewer';
import { DialogProps } from '../DialogProps';
import { TelerikReportViewer } from '@progress/telerik-react-report-viewer';
import styles from './_report-viewer-dialog.module.scss';
import IKeyed from '../../../Interfaces/IKeyed';
export interface ReportViewerDialogProps extends DialogProps<void> {
  reportName: string;
  parameters?: ReportParameter[];
  bearerToken: string;
  baseUrl: string;
  clientId?: string;
  /** Hide the parameters sidebar completely. Defaults to true. */
  parametersAreaVisible?: boolean;
}
export default function ReportViewerDialog(props: ReportViewerDialogProps) {
  const serviceUrl = `${props.baseUrl}/api/reports`;
  const parameters: IKeyed = {};
  props.parameters?.forEach(rp => {
    parameters[rp.name] = rp.value
  });
    // Set up fetch interceptor when component mounts
  useEffect(() => {
    const originalFetch = window.fetch;
    
    window.fetch = function(...args) {
      let [url, options = {}] = args;
      
      if ((url as string)?.includes('/api/reports') === true) {
        options.headers = {
          ...options.headers,
          'X-Client-Id': props.clientId ?? ''
        };
      }
      
      return originalFetch(url, options);
    };

    // Cleanup on unmount
    return () => {
      window.fetch = originalFetch;
    };
  }, [props.clientId]);
    return (
        <>
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
            {props.title}
          </DialogTitle>
          <DialogContent style={{minWidth: 'calc(100vw - 70px)', minHeight: 'calc(100vh - 200px)'}}>
          <div className={styles.reportViewer}>
            <TelerikReportViewer
              serviceUrl={serviceUrl}
              authenticationToken={props.bearerToken}
              reportSource={{
                report: props.reportName,
                parameters: parameters
              }}
              viewerContainerStyle={{
                position: 'absolute',
                left: '0px',
                right: '0px',
                top: '0px',
                bottom: '0px',
                overflow: 'hidden',
                clear: 'both',
                fontFamily: 'ms sans serif'
              }}
              viewMode="INTERACTIVE"
              scaleMode="SPECIFIC"
              scale={1.0}
              enableAccessibility={false}
              parametersAreaVisible={props.parametersAreaVisible ?? true} />
            </div>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={props.closeDialog} color="primary">
              Close
            </Button>            
          </DialogActions>
        </>
      );
}